
























import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component
export default class SearchBar extends Vue {
  @Prop({ default: '请输入姓名或作品名称' }) placeholder!: string;
  @Model('userInputChange', { type: String }) keyword!: string;

  userInput = '';
  show = false;
  @Watch('userInput')
  onKeywordChange(newval: string) {
    this.$emit('userInputChange', newval);
    this.show = true;
    if (!newval.length) {
      this.show = false;
      this.$emit('clear');
    }
  }
  reloadPage() {
    this.$emit('clear');
  }
}
